export default  {
  bindings: {
    pages: '<',
    type: '<'
  },
  controller: 'pageContentListController',
  template: require('../views/pageContent.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.list.component.js